namespace TabAurous.ECommerce {
    export namespace ECommSalesItemsService {
        export const baseUrl = 'ECommSales/ECommSalesItems';

        export declare function Create(request: Serenity.SaveRequest<ECommSalesItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ECommSalesItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ECommSalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ECommSalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<ECommSalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ShipmentItemList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<ECommSalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ECommSales/ECommSalesItems/Create",
            Update = "ECommSales/ECommSalesItems/Update",
            Delete = "ECommSales/ECommSalesItems/Delete",
            Retrieve = "ECommSales/ECommSalesItems/Retrieve",
            List = "ECommSales/ECommSalesItems/List",
            CustomList = "ECommSales/ECommSalesItems/CustomList",
            ShipmentItemList = "ECommSales/ECommSalesItems/ShipmentItemList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList', 
            'ShipmentItemList'
        ].forEach(x => {
            (<any>ECommSalesItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
